/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const postProductAllocationList = (params, otherOptions) =>
  makeApiCall(`/product-allocation-maintenance/list`, 'POST', params, false, otherOptions);

export const postDownloadTemplate = (params) =>
  makeApiCall(`/product-allocation-maintenance/template/export`, 'POST', params);

export const postProductAllocationImport = (params) =>
  makeApiCall(`/product-allocation-maintenance/template/validate`, 'POST', params, true);

export const postProductAllocationExport = (params) =>
  makeApiCall(`/product-allocation-maintenance/export`, 'POST', params);

export const getProductAllocationImportLast = (params) =>
  makeApiCall(`/product-allocation-maintenance/template/get-last-upload-date`, 'GET', params);

export const postProductInventoryBalanceList = (params, otherOptions) =>
  makeApiCall(`/product-sample-inventory-balance/report`, 'POST', params, false, otherOptions);

export const postProductInventoryBalanceExport = (params) =>
  makeApiCall(`/product-sample-inventory-balance/export`, 'POST', params);
